<template>
    <ayuda-tema-base
        :busqueda="busqueda"
        :color="color"
        :faqs="faqs"
        :video-url="videoUrl"
        :video-titulo="$t('mensajes.central_reservas.ayuda_contenido.solicitudes')"
    />
</template>

<script>
import AyudaTemaBase from './AyudaTemaBase.vue';

export default {
    name: 'AyudaTemaSolicitudes',
    components: {
        AyudaTemaBase
    },
    props: {
        busqueda: {
            type: String,
            default: ''
        },
        color: {
            type: String,
            default: '#2E7D32'
        }
    },
    computed: {
        videoUrl() {
            const videosPorIdioma = {
                es: 'https://share.synthesia.io/embeds/videos/0ad913fe-23e9-48ca-aa80-1dd18a17f69c',
                en: 'https://share.synthesia.io/embeds/videos/4ef1f968-a427-435f-bda8-bac771251c83',
                de: 'https://share.synthesia.io/embeds/videos/ff82772d-53c3-4ead-863a-d1e7a7de44e2'
            };

            return videosPorIdioma[this.$i18n.locale] || videosPorIdioma.es;
        },
        faqs() {
            return [
                {
                    id: 1,
                    pregunta: this.$t('mensajes.central_reservas.ayuda_contenido.faqs.solicitudes.1.pregunta'),
                    respuesta: this.$t('mensajes.central_reservas.ayuda_contenido.faqs.solicitudes.1.respuesta')
                },
                {
                    id: 2,
                    pregunta: this.$t('mensajes.central_reservas.ayuda_contenido.faqs.solicitudes.2.pregunta'),
                    respuesta: this.$t('mensajes.central_reservas.ayuda_contenido.faqs.solicitudes.2.respuesta')
                },
                {
                    id: 3,
                    pregunta: this.$t('mensajes.central_reservas.ayuda_contenido.faqs.solicitudes.3.pregunta'),
                    respuesta: this.$t('mensajes.central_reservas.ayuda_contenido.faqs.solicitudes.3.respuesta')
                },
                {
                    id: 4,
                    pregunta: this.$t('mensajes.central_reservas.ayuda_contenido.faqs.solicitudes.4.pregunta'),
                    respuesta: this.$t('mensajes.central_reservas.ayuda_contenido.faqs.solicitudes.4.respuesta')
                },
                {
                    id: 5,
                    pregunta: this.$t('mensajes.central_reservas.ayuda_contenido.faqs.solicitudes.5.pregunta'),
                    respuesta: this.$t('mensajes.central_reservas.ayuda_contenido.faqs.solicitudes.5.respuesta')
                },
                {
                    id: 6,
                    pregunta: this.$t('mensajes.central_reservas.ayuda_contenido.faqs.solicitudes.6.pregunta'),
                    respuesta: this.$t('mensajes.central_reservas.ayuda_contenido.faqs.solicitudes.6.respuesta')
                }
            ];
        }
    }
};
</script>
